import { ReactElement } from "react";
import { NotificationMemberDetails } from "types";
import styles from "../alerts-notification/alerts-notification.module.css";
import { DisplayIcon } from "@justworkshr/milo-icons";

const { alertsNotification, hasAvatar, mdvIcon } = styles;

export default function ContinueHiUpsellAppNotification({
  message,
  url,
}: {
  message: string;
  url?: string;
  member?: NotificationMemberDetails;
}): ReactElement {
  return (
    <div className={`${alertsNotification} ${hasAvatar}`}>
      <DisplayIcon
        className={mdvIcon}
        iconName={"check-on-page"}
        color={"gray"}
      />
      <span>
        <a href={url}>{message}</a>
      </span>
    </div>
  );
}
